"use client";

import { ChakraProvider } from "@chakra-ui/react";
import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";
import { customTheme } from "@/theme";
import { Toaster } from "./toaster";
import useInertiaToasts from "@/hooks/useInertiaToast";

export function Provider(props: ColorModeProviderProps) {
  useInertiaToasts();

  return (
    <ChakraProvider value={customTheme}>
      <Toaster />
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
}
